const PUBLIC_PLATFORM_ENTRY_HOSTS = new Set([
  'moy-gorod.su',
  'www.moy-gorod.su',
  'localhost',
  '127.0.0.1',
  '::1',
  '[::1]',
]);

const normalizeHostname = (hostname?: string | null): string => (
  String(hostname ?? '').trim().toLowerCase().replace(/\.$/, '')
);

export const isPublicPlatformEntryHostname = (hostname?: string | null): boolean => (
  PUBLIC_PLATFORM_ENTRY_HOSTS.has(normalizeHostname(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : ''),
  ))
);

export type PlatformRootEntryKind = 'public' | 'authenticated' | 'protected';

export const getPlatformRootEntryKind = (
  hostname: string | null | undefined,
  isAuthenticated: boolean,
): PlatformRootEntryKind => {
  if (!isPublicPlatformEntryHostname(hostname)) return 'protected';
  return isAuthenticated ? 'authenticated' : 'public';
};

export const getPublicPlatformHomeHref = (hostname?: string | null): string => {
  const normalized = normalizeHostname(
    hostname ?? (typeof window !== 'undefined' ? window.location.hostname : ''),
  );
  if (PUBLIC_PLATFORM_ENTRY_HOSTS.has(normalized)) return '/';
  if (normalized.endsWith('.moy-gorod.su')) return 'https://moy-gorod.su/';
  return '/';
};
